import { fromJS } from 'immutable'
import {
  USER_GET_REQUEST,
  USER_GET_SUCCESS,
  USER_GET_FAILURE,
  USER_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_GET_REQUEST:
      return state
        .set('isFetching', true)
    case USER_GET_SUCCESS:
      return state
        .set('user', fromJS(action.payload.findedUser))
        .set('status', action.payload.ok)
        .set('isFetching', false)
    case USER_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case USER_GET_RESET:
      return state
        .delete('user')
        .delete('status')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-get-reducer.js